import React from 'react';

import Image from 'next/image';

import type { Image as CraveImageType } from '@/services/graphQL/api/generated/types_web';
import { imgCraveLogo, imgCraveLogoShort } from '@/utils/miscIcons';

type LogoProps = {
  variant?: 'small' | 'large' | 'xlarge';
  logoData?: CraveImageType;
  priority?: boolean;
};

// rem values derived from 1080p pixel sizes (÷16px base) so they scale with root font-size
const variantStyles = {
  small: { widthRem: '3.125rem', heightRem: '2.9375rem', widthPx: 50, heightPx: 47 },
  large: { widthRem: '13.75rem', heightRem: '2.4375rem', widthPx: 220, heightPx: 39 },
  xlarge: { widthRem: '41.25rem', heightRem: '7.125rem', widthPx: 660, heightPx: 114 },
};

const Logo: React.FC<LogoProps> = (props: LogoProps) => {
  const { variant = 'large', logoData, priority = false } = props;
  const logoSrc = variant === 'small' ? imgCraveLogoShort : imgCraveLogo;
  const { widthRem, heightRem, widthPx, heightPx } = variantStyles[variant];

  return (
    <Image
      src={logoData?.url ? logoData.url : logoSrc}
      alt={''}
      width={widthPx}
      height={heightPx}
      style={{ width: widthRem, height: heightRem }}
      priority={priority}
    />
  );
};

export default Logo;
